import { TenderMethod } from '@rygen/rygen-ui/model';

import { WaterfallTenderRateQuoteExclusionReason } from './WaterfallTenderRateQuoteExclusionReason';

export class WaterfallTenderExcludedRateQuote {
  rateQuoteId?: number;
  tenderMethod?: TenderMethod;
  reason?: WaterfallTenderRateQuoteExclusionReason;

  constructor(opts?: Partial<WaterfallTenderExcludedRateQuote>) {
    if (opts?.rateQuoteId != null) {
      this.rateQuoteId = opts.rateQuoteId;
    }
    if (opts?.tenderMethod != null) {
      if (typeof opts?.tenderMethod === 'string') {
        this.tenderMethod = TenderMethod[opts.tenderMethod];
      } else {
        this.tenderMethod = opts.tenderMethod;
      }
    }
    if (opts?.reason != null) {
      this.reason = opts.reason;
    }
  }
}
